import { NumberGrid } from '@Animation/mechanics/base/number-grid'
import { NumberSelector } from '@Animation/mechanics/base/number-selector'
import { tweenWaitPromise } from '@Animation/utils'

export class Plus3NumberSelector extends NumberSelector {
  constructor(
    scene: Phaser.Scene,
    numberGrid: NumberGrid,
    miniGameSelections: number[],
    preNumberSelected: (index: number) => Promise<void>,
    onNumberSelected: (number: number) => void,
  ) {
    super(scene, numberGrid, miniGameSelections, preNumberSelected, onNumberSelected)
  }

  async targetSingleNumber(number: number) {
    await tweenWaitPromise(this.scene, 500)()
    await this.numberGrid.selectExtraNumber(number)
  }

  skipTargetSingleNumber(number: number) {
    this.numberGrid.selectExtraNumber(number)
  }

  async skip(numbers: number[]) {
    numbers.forEach((num) => this.numberGrid.selectExtraNumber(num))
    this.onNumberSelected(numbers.length - 1)
  }
}
